(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller("eventLetsMeetController", eventLetsMeetController);

  eventLetsMeetController.$inject = [
    "settings",
    "$scope",
    "$rootScope",
    "$uibModalInstance",
    "userTo",
    "eventObject",
    "EventsLetsMeetApi",
    "handleError",
    "alerts",
    "$timeout",
  ];

  function eventLetsMeetController(
    settings,
    $scope,
    $rootScope,
    $uibModalInstance,
    userTo,
    eventObject,
    EventsLetsMeetApi,
    handleError,
    alerts,
    $timeout,
  ) {
    var vm = this;

    // properties
    vm.isLoading = false;
    vm.isLoadingMessage = "Loading...";
    vm.userTo = userTo;
    vm.thisUser = $rootScope.thisUser;
    vm.formErrors = {};
    vm.letsMeet = {
      message: "",
    };
    vm.eventObject = eventObject;
    vm.forceClose = false;

    // methods
    vm.close = $uibModalInstance.close;
    vm.sendLetsMeet = sendLetsMeet;

    function sendLetsMeet() {
      EventsLetsMeetApi.post(
        {
          id: eventObject.id,
        },
        {
          user_to: vm.userTo.id,
          message: vm.letsMeet.message,
          event_id: vm.eventObject.id,
        },
        function (response) {
          $timeout(function () {
            vm.isLoading = false;

            alerts.emit({
              type: "success",
              title: "Message sent",
              message:
                "A request to meet up has been sent to " + vm.userTo.forename,
            });

            // Close modal
            vm.forceClose = true;
            $uibModalInstance.close(response.data);
          }, 400);
        },
        function handleSaveAdvertError(err) {
          vm.isLoading = false;
          vm.formErrors = err.data;
        },
      );
    }

    // Catch the modal being closed for any reason
    $scope.$on("modal.closing", function (event, reason, closed) {
      if (!closed) {
        return event.preventDefault();
      }

      if (vm.forceClose) {
        return $uibModalInstance.close();
      }

      if (vm.letsMeet.message.length > 0) {
        event.preventDefault();

        // Todo: replace browser confirm with custom
        var exit = confirm("Are you sure?");
        if (exit) {
          vm.forceClose = true;
          $uibModalInstance.close();
        }
      }
    });
  }
})(angular);
